import React, { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  clearLocationRange,
  clearSelectedLocation,
  setSelectedLocation,
} from "../../../../features/geoFence/geoFenceSlice";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import GeoFenceCard from "./GeoFenceCard";
import GoogleMapView from "./GoogleMap";
import { ListItemIcon } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useMaterialUIController } from "context";

function debounce(func, delay) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
}

const GeoFenceRoute = () => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const fetchSuggestions = useCallback(
    debounce((input) => {
      if (!input || !window.google) return setSuggestions([]);

      const service = new window.google.maps.places.AutocompleteService();
      service.getPlacePredictions(
        { input, },
        (predictions, status) => {
          if (
            status === window.google.maps.places.PlacesServiceStatus.OK &&
            predictions
          ) {
            setSuggestions(predictions);
          } else setSuggestions([]);
        }
      );
    }, 300),
    []
  );

  useEffect(() => {
    fetchSuggestions(search);
  }, [search, fetchSuggestions]);

  const handleSelectSuggestion = (place) => {
    dispatch(clearLocationRange());
    dispatch(setSelectedLocation(null));
    dispatch(clearSelectedLocation());
    setSearch(place.description);

    setSuggestions([]);

    if (!window.google) return;

    const map = new window.google.maps.Map(document.createElement("div"));
    const service = new window.google.maps.places.PlacesService(map);

    service.getDetails({ placeId: place.place_id }, (result, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK) {
        const { lat, lng } = result.geometry.location;
        dispatch(
          setSelectedLocation({
            lat: lat(),
            lng: lng(),
            name: place.description,
          })
        );
        console.log("Selected Location:", lat(), lng(), place.description);
      }
    });
    setSearch("");
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <MDBox sx={{ height: "100%", width: "100%", display: "flex", overflow: "hidden" }}>
      {/* 📋 SIDEBAR — ab flex item hai, absolute overlay nahi. Collapse hone par
          width 0 ho jaati hai (map ki jagah automatically free ho jaati hai);
          expand hone par 400px lekar map ko uske bagal push karti hai. */}
      <MDBox
        sx={{
          width: isSidebarOpen ? "400px" : "0px",
          minWidth: isSidebarOpen ? "400px" : "0px",
          height: "100%",
          flexShrink: 0,
          boxShadow: isSidebarOpen ? "2px 0 6px rgba(0,0,0,0.1)" : "none",
          overflowY: isSidebarOpen ? "auto" : "hidden",
          overflowX: "hidden",
          backgroundColor: "white",
          zIndex: 10,
          transition: "width 0.3s ease-in-out, min-width 0.3s ease-in-out",
        }}
      >
        <MDBox sx={{ width: "400px" }}>
          <GeoFenceCard />
        </MDBox>
      </MDBox>

      <MDBox sx={{ flex: 1, height: "100%", position: "relative", minWidth: 0 }}>
        <GoogleMapView
          style={{ height: "100%", width: "100%" }}
          isSidebarOpen={isSidebarOpen}
        />

        <MDButton
          sx={{
            position: "absolute",
            top: "20px",
            left: "20px",
            zIndex: 15,
            borderRadius: "50%",
            minWidth: "40px",
            width: "40px",
            height: "40px",
            padding: 0,
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
            backgroundColor: "white",
            color: "black",
          }}
          onClick={toggleSidebar}
        >
          {isSidebarOpen ? "←" : "→"}
        </MDButton>

        <MDBox
          sx={{
            position: "absolute",
            top: "10px",
            right: "70px",
            width: "600px",
            zIndex: 20,
          }}
        >
          <MDInput
            fullWidth
            sx={{
              backgroundColor: darkMode
                ? "#1f283e !important"
                : "white !important",
              borderRadius: "12px",
              width: "100%",
              boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
              overflow: "hidden",
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderRadius: "12px",
              },
            }}
            placeholder="Search location..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          {suggestions.length > 0 && (
            <MDBox
              sx={{
                background: darkMode ? "#1f283e" : "white",
                borderRadius: "8px",
                mt: 1,
                boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                maxHeight: "250px",
                overflowY: "auto",
                zIndex: 30,
              }}
            >
              {suggestions.map((place) => (
                <MDBox
                  key={place.place_id}
                  onClick={() => handleSelectSuggestion(place)}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "18px",
                    "&:hover": {
                      backgroundColor: "rgba(25, 118, 210, 0.08)",
                    },
                  }}
                >
                  <ListItemIcon>
                    <LocationOnIcon color="action" />
                  </ListItemIcon>

                  {place.description}
                </MDBox>
              ))}
            </MDBox>
          )}
        </MDBox>
      </MDBox>
    </MDBox>
  );
};

export default GeoFenceRoute;